import React from 'react';

const sectors = ['Legal services', 'Field operations', 'SaaS', 'Sports data', 'E-commerce'];

const TrustBar = () => (
  <section className="border-y border-[#DCE4E8] bg-white px-6 py-7 lg:px-8" aria-label="Industries represented in our work">
    <div className="mx-auto flex max-w-7xl flex-col gap-5 md:flex-row md:items-center md:justify-between">
      <p className="shrink-0 text-[11px] font-bold uppercase tracking-[0.18em] text-[#82939C]">Work across</p>
      <div className="flex flex-wrap gap-x-7 gap-y-3 md:justify-end">
        {sectors.map((sector) => (
          <span key={sector} className="text-sm font-semibold text-[#334D5B]">{sector}</span>
        ))}
      </div>
    </div>
  </section>
);

export default TrustBar;
